import React from 'react';
import { func } from 'prop-types';
import { connect } from 'react-redux';
import { Collapse, Icon } from 'antd';

import Form from '../../components/FiltersForm';

import {
  directions,
  game,
  platform,
  eventTypes,
  versions,
  channels,
  classTags,
  typeTags,
  techTags,
} from '../../store/selectors/collections';

const { Panel } = Collapse;

const FiltersBar = props => {
  const { onFormSubmit } = props;

  return (
    <>
      <Collapse defaultActiveKey={['1']}>
        <Panel header="Filters" extra={<Icon type="filter" />} key="1">
          <Form {...props} onSubmit={onFormSubmit} />
        </Panel>
      </Collapse>
    </>
  );
};

FiltersBar.propTypes = {
  onFormSubmit: func.isRequired,
};

const mapStateToProps = state => {
  return {
    directions: directions(state),
    eventTypes: eventTypes(state),
    platform: platform(state),
    game: game(state),
    versions: versions(state),
    channels: channels(state),
    classTags: classTags(state),
    typeTags: typeTags(state),
    techTags: techTags(state),
  };
};

export default connect(mapStateToProps)(FiltersBar);
